import { ProductItem, ProductData } from 'data/types/product';

export const normalizeProductItem = (data: ProductItem) => ({
  name: data.name,
  count: data.count,
  sales: data.sales,
});

export const normalizeProduct = (data: ProductData) => ({
  updatedAt: data.updatedAt,
  topItems: data.topItems,
  bottomItems: data.bottomItems,
  allItems: data.allItems
    .map(normalizeProductItem)
    .sort((a, b) => (a.sales > b.sales ? -1 : 1)),
});

export type Product = ReturnType<typeof normalizeProduct>;
